export function getChatBaseUrl() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  const fromEnv = process.env.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL_PRODUCTION;
  return fromEnv ? String(fromEnv).replace(/\/$/, "") : "";
}

export function slugifyEventName(name) {
  return encodeURIComponent(String(name || "event").replace(/\s+/g, "-"));
}

export function buildEventDetailPath(event) {
  const id = event?.id;
  if (!id) return "/tickets";
  const slug = slugifyEventName(event?.name);
  return `/tickets/group.details/${id}/${slug}`;
}

export function buildEventDetailUrl(event, baseUrl) {
  const path = event?.link || buildEventDetailPath(event);
  if (!baseUrl) return path;
  const origin = String(baseUrl).replace(/\/$/, "");
  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}

export function isMongoEventId(id) {
  if (id == null || id === "") return false;
  return /^[a-f\d]{24}$/i.test(String(id));
}

/** Normalize wrapper or flat event into a share payload with the correct route id. */
export function buildShareItemFromEvent(wrapperOrEvent) {
  const wrapper =
    wrapperOrEvent?.event && Array.isArray(wrapperOrEvent.event)
      ? wrapperOrEvent
      : null;
  const ev = wrapper?.event?.[0] || wrapperOrEvent || {};
  const mongoId =
    (wrapper?._id && isMongoEventId(wrapper._id) ? wrapper._id : null) ||
    (isMongoEventId(ev?._id) ? ev._id : null);
  const id = mongoId || ev?.id || ev?._id;
  return {
    id,
    _id: id,
    name: ev?.name || "Event",
    venue: ev?.venue,
    occurs_at_local: ev?.occurs_at_local || ev?.occurs_at,
    _isUserCreated: Boolean(ev?._isUserCreated || mongoId),
  };
}

export function buildEventShareUrl(item) {
  const shareItem = item?.id || item?._id ? item : buildShareItemFromEvent(item);
  const path = buildEventDetailPath(shareItem);
  const base = getChatBaseUrl();
  if (!base) return path;
  return `${String(base).replace(/\/$/, "")}${path}`;
}

export function withEventLinks(event, baseUrl) {
  const link = event?.link || buildEventDetailPath(event);
  return {
    ...event,
    link,
    url: buildEventDetailUrl({ ...event, link }, baseUrl),
  };
}

export function formatTicketLinkLine(event, baseUrl, label = "View tickets") {
  return `${label}: ${buildEventDetailUrl(event, baseUrl)}`;
}
